import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const InvitationsSecondaryViewStore = GenericFieldFactory("INVITATIONS_SECONDARY_VIEW", null);